import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import DropDown from '../../../../../../../components/DropDown';
import {useGetAllDropdownAssignmentsMutation} from '../../../../../../../features/authentication/assignmentApislice';
import PropTypes from 'prop-types';

const AddQuestionsToExisting = ({handleSave, handleCancel})=>
{
  const [assignments, setAssignments] = useState([]);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState(null);
  const [getAllDropdownAssignments] = useGetAllDropdownAssignmentsMutation();

  useEffect(() => {   
    const fetchAssignmentData = async () => {
      const obj = {
        id: 0,
        name: 'Select Assignment'
      };
      var assignments = await getAllDropdownAssignments().unwrap();
      const assignmentsArray = [obj, ...assignments];
      setAssignments(assignmentsArray);   
    };
    fetchAssignmentData();

  }, [getAllDropdownAssignments]);

  const handleSelectAssignment = (event) => {
    setSelectedAssignmentId(parseInt(event.target.value));
  };

  const saveOnClick = ()=>
  {
    if(selectedAssignmentId && selectedAssignmentId>0)
    {
      handleSave(selectedAssignmentId);
    }else{
      setSelectedAssignmentId(0);
    }
  };

  return (
    <>
      <Row className='mb-5'>
        <Col className="">
          <DropDown
            label="Select an Assignment"
            value={assignments}
            onChangeHandler={(e) => handleSelectAssignment(e)}
            selectedValue={selectedAssignmentId}
            showValidation={selectedAssignmentId == 0}
            validationMessage ="Please Select Assignment"
            disabledMessage={'Questions cannot be added to an assignment that already has students assigned to it'}
          />
        </Col>
      </Row>
      <Row>
        <div className="d-flex justify-content-end gap-3 align-items-center">
          <button className="btn btn-castleGray option-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn btn-castleRed option-btn" onClick={saveOnClick}>
            Save
          </button>        
        </div>  
      </Row>
    </>
  );
};

AddQuestionsToExisting.propTypes = {
  handleSave: PropTypes.func,
  handleCancel: PropTypes.func
};

export default AddQuestionsToExisting;